module.exports = __webpack_public_path__ + "img/how-to-use-scanner.178e0fbd.png";